import { useCookiesWithPermission } from "@RHCommerceDev/hooks/useCookiesWithPermission";

export const useSetCookie = () => {
  const { setCookieWrapper } = useCookiesWithPermission();

  return {
    setCookie: setCookieWrapper
  };
};
